import { mergeStreamingText } from '../../utils/mergeStreamingText';

export type FixEventKind = 'chat' | 'delta' | 'tool_update';

/**
 * Decide how a live fix-job event is rendered.
 *
 * Dispatched sub-agents stream their prose only as `assistant_delta` events.
 * The main agent's deltas are skipped: run_fix_job already relays that text as
 * `chat_message` events, so rendering both would duplicate it.
 */
export const classifyFixEvent = (event: any): FixEventKind | null => {
  if (!event || typeof event !== 'object') return null;
  if (event.event_type === 'chat_message') return 'chat';
  if (event.event_type === 'assistant_delta' && event.sub_agent_info) return 'delta';
  if (event.event_type === 'tool_streaming_update') return 'tool_update';
  return null;
};

/**
 * Combine an incoming chunk with a message's existing text.
 *
 * Deltas carry only new text for their uuid, so they are appended verbatim;
 * guessing via mergeStreamingText would drop a chunk that repeats the tail
 * of the text so far.
 */
export const mergeFixMessageText = (existing: string, incoming: string, isDelta: boolean): string =>
  isDelta ? existing + incoming : mergeStreamingText(existing, incoming);

/** Whitespace-only chat messages are noise, but whitespace deltas are content. */
export const isRenderableFixText = (text: string, isDelta: boolean): boolean =>
  !!text && (isDelta || text.trim() !== '');
